export default __webpack_public_path__ + "static/media/logo-apdp.21468921.svg";